'use client';

import { TextareaHTMLAttributes } from 'react';
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/atoms/form';
import { Control, FieldValues, Path } from 'react-hook-form';

interface FormattedTextareaProps<TFieldValues extends FieldValues>
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  placeholder?: string;
  maxLength?: number;
  className?: string;
}

export function FormattedTextarea<TFieldValues extends FieldValues>({
  control,
  name,
  placeholder,
  maxLength,
  className,
  ...rest
}: FormattedTextareaProps<TFieldValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem className="flex-1">
            <FormControl>
              <textarea
                placeholder={placeholder}
                {...field}
                {...rest}
                maxLength={maxLength}
                className={`flex min-h-[120px] w-full rounded-md border border-gray-200 bg-transparent px-[20px] py-[16px] text-sm shadow-sm placeholder:text-opacity-40 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${className || ''}`}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
}
